import React from 'react';
import {Link} from 'react-router-dom';

import Authenticated from 'Components/Layouts/Authenticated';
import {Loading} from 'Components/Partials';
import {Input, RenderWYSIWYG} from 'Components/Form';

import ExhibitorApi from 'Services/Api/Exhibitor/Exhibitor';
import {translation} from 'Services/TranslationHelpers';

export default class ExhibitorIndex extends React.Component {
    /**
     * @var state
     */
    state = {
        loading: true,
        exhibitors: null,
        search: '',
    };

    /**
     * @method componentDidMount
     * @return {Promise<void>}
     */
    componentDidMount = async () => {
        await this.fetchExhibitors();
    };

    /**
     * @method fetchExhibitor
     * @param {string} search
     * @return {Promise<void>}
     */
    fetchExhibitors = async (search = '') => {
        this.setState({search});

        const response = await ExhibitorApi.getExhibitors(search);

        this.setState({
            loading: false,
            exhibitors: response.data.data
        });
    };

    /**
     * @method render
     * @return {*}
     */
    render() {
        const {loading} = this.state;

        return (
            <Authenticated pageTitle="Exhibitors" headerImage={'/images/headers/exhibitors.png'}>
                <div className={'bg-light-blue-700 text-app-blue p-6 max-w-7xl mx-auto'}>
                    <div className="my-8">
                        <p className={ "text-xl my-10 text-center" }>
                            Please take the opportunity to explore our partners exhibiting at the Symposium.
                            Click on the logos to learn more and find out how to connect with them.
                        </p>
                    </div>

                    <div className="w-full pb-8">
                        {loading && (<Loading/>)}

                        {!loading &&
                            <div className=" w-full">
                                {this.renderMenu()}
                            </div>
                        }
                    </div>
                </div>
            </Authenticated>
        );
    }

    /**
     * @method renderMenu
     * @return {*}
     */
    renderMenu() {
        const {exhibitors, search} = this.state;

        return (
            <div className="text-app-blue p-4 h-full exhibitors-menu">
                {/*<div className="pt-6 mb-6 relative">*/}
                {/*    <Input*/}
                {/*        placeholder={translation('misc', 'search') + '...'}*/}
                {/*        onChange={(v) => this.fetchExhibitors(v)}*/}
                {/*        value={search}*/}
                {/*        className="rounded-full px-6"*/}
                {/*    />*/}
                {/*</div>*/}

                <div className="overflow-y-auto w-full" >
                    {window.base.exhibitor_zones && window.base.exhibitor_zones.map((zone, i) => {
                        return (
                            <div className="mb-6 px-2 uppercase">
                                <div key={i} className="py-2 px-5 rounded-full mb-4">
                                    {zone}
                                </div>
                                <div className="px-4 grid grid-cols-1 lg:grid-cols-4 ">
                                    {exhibitors.filter(i => i.zone === zone).map((exhibitor, j) => (
                                        this.renderExhibitor(exhibitor, j)
                                    ))}
                                </div>
                            </div>
                        );
                    })}

                    {!window.base.exhibitor_zones &&
                        <div className="px-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
                            {exhibitors.map((exhibitor, j) => (
                                this.renderExhibitor(exhibitor, j)
                            ))}
                        </div>
                    }
                </div>
            </div>
        );
    }

    /**
     * @method renderLeftMenu
     * @param {object} exhibitor
     * @param {integer} key
     * @return {*}
     */
    renderExhibitor(exhibitor, key) {
        return (
            <div className="hover:bg-app-light-blue p-4 exhibitor-card" key={key}>
                <Link to={'/exhibitors/'+exhibitor.id}>
                    {/*<p className="text-lg font-bold">*/}
                    {/*    {exhibitor.name}*/}
                    {/*</p>*/}
                    {/*<p className="mt-2">*/}
                    {/*    {exhibitor.menu_bio}*/}
                    {/*</p>*/}
                    {exhibitor.logo && exhibitor.logo.url &&
                        <img src={exhibitor?.logo?.url} alt={exhibitor.name} className="w-full h-52 object-contain" />
                    }
                    {!exhibitor.logo && (
                        <div className="w-full min-h-52 h-52 md:h-full bg-gray-200 flex items-center justify-center">
                            <p>{exhibitor.name}</p>
                        </div>
                    )}

                </Link>
            </div>
        );
    }
}
